import { NotificationTrapImageInsectsVariationSettings } from '../models/Entities';
import dateService from '../services/DateService';
import { coreApiAxios } from './CustomAxios';

class NotificationTrapImageInsectsVariationSettingsApi {
    list = async (companyId: number): Promise<NotificationTrapImageInsectsVariationSettings[]> => {
        const response = await coreApiAxios.get<NotificationTrapImageInsectsVariationSettings[]>('/notification-trap-image-insects-variation-settings', {
            params: { companyId }
        });
        response.data.forEach((ntiivs) => this.loadDates(ntiivs));

        return response.data;
    };

    get = async (id: number): Promise<NotificationTrapImageInsectsVariationSettings> => {
        const response = await coreApiAxios.get<NotificationTrapImageInsectsVariationSettings>(`/notification-trap-image-insects-variation-settings/${id}`);
        this.loadDates(response.data);

        return response.data;
    };

    create = async (settings: NotificationTrapImageInsectsVariationSettings): Promise<NotificationTrapImageInsectsVariationSettings> => {
        const response = await coreApiAxios.post<NotificationTrapImageInsectsVariationSettings>(
            `/notification-trap-image-insects-variation-settings`,
            settings
        );
        this.loadDates(response.data);

        return response.data;
    };

    update = async (settings: NotificationTrapImageInsectsVariationSettings): Promise<NotificationTrapImageInsectsVariationSettings> => {
        const response = await coreApiAxios.put<NotificationTrapImageInsectsVariationSettings>(
            `/notification-trap-image-insects-variation-settings/${settings.id}`,
            settings
        );
        this.loadDates(response.data);

        return response.data;
    };

    delete = async (id: number): Promise<void> => {
        const response = await coreApiAxios.delete<void>(`/notification-trap-image-insects-variation-settings/${id}`);

        return response.data;
    };

    /**
     * Loads the dates of an notification trap image insects variation settings.
     * @param settings - the notification trap image insects variation settings
     */
    private loadDates(settings: NotificationTrapImageInsectsVariationSettings) {
        settings.audit!.created = dateService.transformDate(settings.audit!.created)!;
        settings.audit!.updated = dateService.transformDate(settings.audit!.updated)!;
    }
}

const notificationTrapImageInsectsVariationSettingsApi: NotificationTrapImageInsectsVariationSettingsApi =
    new NotificationTrapImageInsectsVariationSettingsApi();
export default notificationTrapImageInsectsVariationSettingsApi;
